import { computed, defineComponent, inject, onMounted, onUnmounted, PropType, ref } from 'vue';
import { globalWindowKey } from '@/common/domain/Window';
import { useI18n } from 'vue-i18n';
import { fromMillisecondsLeft } from '@/common/primary/Countdown.ui';
import { AuctionUi } from '@/fairplayer/primary/marketplace/Auction.ui';

export default defineComponent({
  name: 'LiveAuctionFooter',

  props: {
    auction: {
      type: Object as PropType<AuctionUi>,
      required: true,
    },
  },

  setup(props) {
    const globalWindow = inject(globalWindowKey)!;
    const { t } = useI18n();

    const intervalId = ref(0);
    const now = ref(Date.now());

    const millisecondsBeforeEndDate = computed(() => props.auction.endDate.getTime() - now.value);
    const countdownBeforeEndDate = computed(() => fromMillisecondsLeft(millisecondsBeforeEndDate.value));

    const updateNow = () => {
      now.value = Date.now();
    };

    onMounted(() => {
      intervalId.value = globalWindow.setInterval(updateNow, 1000);
    });

    onUnmounted(() => {
      globalWindow.clearInterval(intervalId.value);
    });

    return {
      t,
      millisecondsBeforeEndDate,
      countdownBeforeEndDate,
    };
  },
});
